import { Button, Paper, Stack, Typography } from '@mui/material';
import EmptyPage from '../utility_objects/EmptyPage';

function SomethingWrong() {
  return (
    <EmptyPage>
      <Paper sx={{ zIndex: 1000, padding: '20px' }}>
        <Stack flexDirection="column" spacing={3}>
          <Typography variant="h4" gutterBottom>
            Attenzione
          </Typography>
          <Typography variant="body1" gutterBottom>
            Qualcosa è andato storto.
            <br />
            Se il problema persiste, contatta il supporto tecnico.
          </Typography>
          <Stack flexDirection="row" justifyContent="end">
            <Button
              variant="outlined"
              onClick={() => {
                window.location.reload();
              }}
            >
              Ricarica la pagina
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </EmptyPage>
  );
}

export default SomethingWrong;
